"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedOrganizationTypes = exports.OrganizationTypeToReviewObjectType = exports.ReviewObjectTypeToOrganizationType = void 0;
const types_1 = require("./types");
exports.ReviewObjectTypeToOrganizationType = {
    [types_1.ReviewObjectTypes.Banks]: types_1.OrganizationTypes.Bank,
    [types_1.ReviewObjectTypes.InsuranceCompany]: types_1.OrganizationTypes.Insurance,
    [types_1.ReviewObjectTypes.Mfi]: types_1.OrganizationTypes.Mfo,
    [types_1.ReviewObjectTypes.Broker]: types_1.OrganizationTypes.Broker,
    [types_1.ReviewObjectTypes.EducationalOrganization]: types_1.OrganizationTypes.EducationalOrganization,
    [types_1.ReviewObjectTypes.Npf]: types_1.OrganizationTypes.Npf,
    [types_1.ReviewObjectTypes.Leasing]: types_1.OrganizationTypes.Leasing,
    [types_1.ReviewObjectTypes.Marketplace]: types_1.OrganizationTypes.Marketplace,
    [types_1.ReviewObjectTypes.Bankruptcy]: types_1.OrganizationTypes.Bankruptcy,
    [types_1.ReviewObjectTypes.University]: types_1.OrganizationTypes.University,
    [types_1.ReviewObjectTypes.Bookmaker]: types_1.OrganizationTypes.Bookmaker,
    [types_1.ReviewObjectTypes.Investment]: types_1.OrganizationTypes.Investment,
    [types_1.ReviewObjectTypes.OfflineSchool]: types_1.OrganizationTypes.OfflineSchool,
};
exports.OrganizationTypeToReviewObjectType = {
    [types_1.OrganizationTypes.Bank]: types_1.ReviewObjectTypes.Banks,
    [types_1.OrganizationTypes.Insurance]: types_1.ReviewObjectTypes.InsuranceCompany,
    [types_1.OrganizationTypes.Mfo]: types_1.ReviewObjectTypes.Mfi,
    [types_1.OrganizationTypes.Broker]: types_1.ReviewObjectTypes.Broker,
    [types_1.OrganizationTypes.EducationalOrganization]: types_1.ReviewObjectTypes.EducationalOrganization,
    [types_1.OrganizationTypes.Npf]: types_1.ReviewObjectTypes.Npf,
    [types_1.OrganizationTypes.Leasing]: types_1.ReviewObjectTypes.Leasing,
    [types_1.OrganizationTypes.Marketplace]: types_1.ReviewObjectTypes.Marketplace,
    [types_1.OrganizationTypes.Bankruptcy]: types_1.ReviewObjectTypes.Bankruptcy,
    [types_1.OrganizationTypes.University]: types_1.ReviewObjectTypes.University,
    [types_1.OrganizationTypes.Bookmaker]: types_1.ReviewObjectTypes.Bookmaker,
    [types_1.OrganizationTypes.OfflineSchool]: types_1.ReviewObjectTypes.OfflineSchool,
};
exports.supportedOrganizationTypes = [
    types_1.OrganizationTypes.Bank,
    types_1.OrganizationTypes.Insurance,
    types_1.OrganizationTypes.Mfo,
    types_1.OrganizationTypes.EducationalOrganization,
    types_1.OrganizationTypes.Broker,
    types_1.OrganizationTypes.Npf,
    types_1.OrganizationTypes.Leasing,
    types_1.OrganizationTypes.Bankruptcy,
    types_1.OrganizationTypes.University,
    types_1.OrganizationTypes.Bookmaker,
    types_1.OrganizationTypes.Marketplace,
    types_1.OrganizationTypes.OfflineSchool,
];
